import mitt from 'mitt';

const eventbus = () => {
	const emitter = mitt();
	let previousEvents = {};

	const subscribe = (topic, callback, options = {}) => {
		const {replay = false} = options;
		if (replay && previousEvents.hasOwnProperty(topic)) {
			callback(previousEvents[topic]);
		}
		return emitter.on(topic, callback);
	}

	const unsubscribe = (topic, callback) => {
		return emitter.off(topic, callback);
	}

	const publish = (topic, args) => {
		previousEvents[topic] = args;
		return emitter.emit(topic, args);
	}

	const once = (topic, callback, options = {}) => {
		const fn = (args) => {
			emitter.off(topic, fn);
			callback(args)
		}
		subscribe(topic, fn, options);
	}

	const all = () => {
		return previousEvents;
	}

	const clear = () => {
		previousEvents = {};
		return emitter.all.clear();
	}

	return {
		subscribe,
		unsubscribe,
		publish,
		once,
		all,
		clear
	}

}

datapas.events = eventbus();


